var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCQfOlvha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9dbntx5ga",
    x1: "50%",
    x2: "0%",
    y1: "50%",
    y2: "94.55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#262626",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#262626",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "9eion3j1xb",
    width: "102.9%",
    height: "104%",
    x: 0,
    y: 0,
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.196078431 0 0 0 0 0.137254902 0 0 0 0 0.607843137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#g9dbntx5ga)",
    transform: "translate(-1250.000000, -497.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#9eion3j1xb)",
    transform: "translate(889.000000, 494.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.017 4L445 87.994 356.017 87.994z",
    transform: "translate(400.508434, 45.996762) rotate(-180.000000) translate(-400.508434, -45.996762)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCQfOlvha);
export default __webpack_public_path__ + "static/media/cQFOlvha.3c60904c822801d3dd2113b4d755aef2.svg";
export { ForwardRef as ReactComponent };